import React from 'react'
import Videos from '../Videos';
import { useHistory } from 'react-router-dom'

const DBDA_CL = React.memo(() => {

    const history = useHistory();

    const nextRoute = () => {
        history.push('/question7')
    }

    const title = "CL-Clerical ability";
    const url = "https://careers4me.in/videos/Clerical_ability.mp4";

    return (
        <Videos title={title} url={url} onPress={nextRoute} />
    )
});

export default DBDA_CL